import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createMutabakat } from "@/services/mutabakatService";

export const submitMutabakat = createAsyncThunk(
  "mutabakat/submit",
  async ({ zipFileName, files }, { rejectWithValue }) => {
    try {
      const data = await createMutabakat({ zipFileName, files });
      return data;
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err?.message ||
        "Form gönderilirken bir hata oluştu.";
      return rejectWithValue(message);
    }
  }
);

const initialState = {
  loading: false,
  result: null, // { items, bytes, fileName, contentType }
  error: null,
};

const mutabakatSlice = createSlice({
  name: "mutabakat",
  initialState,
  reducers: {
    resetMutabakat: (state) => {
      state.loading = false;
      state.result = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitMutabakat.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.result = null;
      })
      .addCase(submitMutabakat.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(submitMutabakat.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Bilinmeyen bir hata oluştu.";
      });
  },
});

export const { resetMutabakat } = mutabakatSlice.actions;
export default mutabakatSlice.reducer;
